import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'privacy.title',
    defaultMessage: 'Privacy Policy',
  },
  button: {
    id: 'privacy.button',
    defaultMessage: 'I Understand',
  },
});
